import { DrilldownTableConfigContextProvider } from 'features/drilldown/components/table/config/DrilldownTableConfigContext'
import {
  DrilldownTable,
  DrilldownTablePanelData,
} from 'features/drilldown/components/table/DrilldownTable'
import { TooltipParagraph } from 'features/drilldown/components/TooltipParagraph'
import { filterLatestCompleteLibraTicketRows } from 'features/drilldown/panels/impl/niiLibraResultsByZoneTable/expandLibraNiiTicketZoneRows'
import { FC, ReactNode } from 'react'
import { RolodexEntryType, RolodexHistogramFilter } from 'types'

import {
  DEFAULT_NII_LIBRA_RESULTS_TABLE_PANEL_DATA,
  NII_LIBRA_RESULTS_TABLE_CONFIG_PROPS,
} from './NiiLibraResultsTable'

export const NII_CAMPAIGN_TITLE = '2026 NII Campaign - ADNOC Gas'

/**
 * The two built-in filters this panel always applies. They are hardcoded
 * (not user-editable) and never surface as column searches or active-filter
 * tags - they're injected straight into the rolodex query.
 */
export const NII_RESULTS_FILTERS: ReadonlyArray<RolodexHistogramFilter> = [
  {
    type: RolodexEntryType.LIBRA_TICKET,
    key: 'workflowComplete',
    op: 'truthy',
  },
  {
    type: RolodexEntryType.LIBRA_TICKET_GROUP,
    field: 'data',
    key: 'title',
    op: '=',
    value: NII_CAMPAIGN_TITLE,
  },
]

export const DEFAULT_NII_RESULTS_PANEL_DATA: DrilldownTablePanelData = {
  ...DEFAULT_NII_LIBRA_RESULTS_TABLE_PANEL_DATA,
  title: 'NII Analysis Results',
}

export const NII_LIBRA_RESULTS_TITLE_TOOLTIP: ReactNode = (
  <TooltipParagraph>
    Scoped to <b>{NII_CAMPAIGN_TITLE}</b>, and only shows the latest{' '}
    <b>complete</b> or <b>fully drafted</b> ticket for each analysis &mdash; one
    row per ticket.
  </TooltipParagraph>
)

export const NiiLibraResultsPanel: FC = () => {
  return (
    <DrilldownTableConfigContextProvider
      {...NII_LIBRA_RESULTS_TABLE_CONFIG_PROPS}
      additionalRolodexFilters={NII_RESULTS_FILTERS}
      paginatedTableOptions={{
        ...NII_LIBRA_RESULTS_TABLE_CONFIG_PROPS.paginatedTableOptions,
        expandRecords: filterLatestCompleteLibraTicketRows,
      }}>
      <DrilldownTable />
    </DrilldownTableConfigContextProvider>
  )
}
